/*********************
* Internal State *
*
* This class models the agent's internal representation of state,
* across the course of an activity.
*
* We may choose to deprecate this when we move away from the heuristic policy.
*********************/
import { interventionSituationTypes } from './constants';

export default class InternalState {
  constructor(){
    this.interventionHistoryByPhrase = [];
    this.interventionsInCurrentPhrase = [];
    this.gsfWordBank = undefined;
  }

  trackAction(action, state) {
    // Note: in this context, "scope" refers to the selection scenario, not the intervention type.
    // "scope" is an overloaded term, with a different connotation in lexa-app.
    if(state.interactions.scope.toUpperCase() == interventionSituationTypes.WORD) {
      this.trackWordLevelIntervention(action.intervention, state.interactions.inWord); // TODO add word that is intervened on
    } else if (state.interactions.scope.toUpperCase() == interventionSituationTypes.PHRASE){
      this.trackPhraseLevelIntervention(action.intervention, action.metadata.word, state.story.textMetadataForCurrentPhrase.phraseIndex); // TODO add word that is intervened on
    }
  }

  // Accumulate an array of interventions in the phrase
  trackWordLevelIntervention(type, word) {
    this.interventionsInCurrentPhrase.push({
      type,
      word,
      situation: interventionSituationTypes.WORD,
    });
  }

  // Push all interventions in the phrase to the history
  trackPhraseLevelIntervention(type, word, phraseIndex) {
    this.interventionsInCurrentPhrase.push({
      type,
      word,
      situation: interventionSituationTypes.PHRASE,
    });

    if((phraseIndex) >= this.interventionHistoryByPhrase.length) {
      this.interventionHistoryByPhrase.push(this.interventionsInCurrentPhrase);
    }
    this.interventionsInCurrentPhrase = [];
  }

  getInterventionHistoryByPhrase() {
    if(this.interventionsInCurrentPhrase.length > 0) {
      return [
        ...this.interventionHistoryByPhrase,
        this.interventionsInCurrentPhrase,
      ];
    } else {
      return this.interventionHistoryByPhrase;
    }
  }

  setGsfWordBank(wordBank) {
    this.gsfWordBank = wordBank;
  }

  getGsfWordBank() {
    return this.gsfWordBank;
  }
}